import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

// even though this gets `notifications` the service is singular
// so will keep the naming convention singular
export const getUnreadNotificationCount = () =>
  call(websocketFetch, 'unread_notification_count');
